import { render, staticRenderFns } from "./progress-type-icon.vue?vue&type=template&id=670429ad&"
import script from "./progress-type-icon.vue?vue&type=script&lang=ts&"
export * from "./progress-type-icon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports